// extracted by mini-css-extract-plugin
export default {"main_div":"BgImage_main_div__XTQfF","mainBgImg":"BgImage_mainBgImg__xvAeM","img_head":"BgImage_img_head__3QTw6","group":"BgImage_group__TmKV9"};